export function resolveBffUrl(bffUrl: string, enableDebugMode: boolean): string {
  const hostname = window.location.hostname;
  if (enableDebugMode) {
    console.log('🌐 [BffUrlResolver] Determinando BFF URL para hostname:', hostname);
  }

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '';
  }

  // UAT Cloud Bancovw
  if (hostname.includes('cons.pp.cld.bancovw.com.br')) {
    return 'https://bff-leads.cons.pp.cld.bancovw.com.br';
  }

  // DEV Cloud Bancovw
  if (hostname.includes('dev.productsportal.cld.bancovw.internal')) {
    return 'http://bff-leads.dev.productsportal.cld.bancovw.internal';
  }

  // Produção
  if (hostname.includes('leads.pp.cld.bancovw.com.br')) {
    return 'https://bff-leads.pp.cld.bancovw.com.br';
  }

  // Fallback: usa bffUrl já resolvido
  return bffUrl;
}
